(function () {
  'use strict';

  // Price gate (16. august 2026): B2B status is decided SERVER-SIDE in Liquid
  // and exposed as data-bc-b2b="true" on <html> (layout/theme.liquid), where
  // customer.b2b? is authoritative. Never re-derive it in JS from login state.
  // Missing attribute is treated as NOT B2B (fail closed).
  function canShowPrices() {
    return document.documentElement.getAttribute('data-bc-b2b') === 'true';
  }

  function onClick(event) {
    var minus = event.target.closest('[data-bc-qty-minus]');
    var plus = event.target.closest('[data-bc-qty-plus]');
    if (minus || plus) {
      var wrap = event.target.closest('[data-bc-qty]');
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      if (!input) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      v = plus ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      return;
    }

    var btn = event.target.closest('[data-bc-card-wishlist]');
    if (!btn) return;
    event.preventDefault();
    var id = btn.getAttribute('data-bc-card-id');
    if (!id || !window.BCWishlist) return;
    var meta = {
      title:  btn.getAttribute('data-product-title') || '',
      url:    btn.getAttribute('data-product-url') || '',
      image:  btn.getAttribute('data-product-image') || '',
      vendor: btn.getAttribute('data-product-vendor') || ''
    };
    // Price gate: the amount is only persisted for a B2B customer. Otherwise it
    // would sit in localStorage and be painted back into the favourites drawer
    // on a later visit when the visitor no longer has price access.
    if (canShowPrices()) {
      meta.price = btn.getAttribute('data-product-price') || '';
    }
    window.BCWishlist.toggle(id, meta);
  }

  function onSubmit(event) {
    var form = event.target.closest('form[data-bc-card-quick-add]');
    if (!form) return;
    event.preventDefault();
    form.classList.remove('bc-card__quick-add--error');
    var qty = form.querySelector('input[name="quantity"]');
    if (qty) {
      var q = parseInt(qty.value, 10);
      if (isNaN(q) || q < 1) qty.value = 1;
    }
    var fd = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (res.ok) {
          document.dispatchEvent(new CustomEvent('bc:cart:added', { detail: res.data }));
        } else {
          form.classList.add('bc-card__quick-add--error');
        }
      })
      .catch(function () { form.classList.add('bc-card__quick-add--error'); });
  }

  function pluralDays(n) {
    var s = (window.BCStrings && window.BCStrings.campaign_days_left);
    if (s && typeof s === 'object') {
      return String(n === 1 ? s.one : s.other).replace('{{count}}', String(n)).replace('{n}', String(n));
    }
    return String(s || '{n} days left').replace('{n}', String(n)).replace('{{count}}', String(n));
  }
  function todayText() {
    return (window.BCStrings && window.BCStrings.campaign_today) || 'Ends today';
  }

  function refreshCampaignBadges(root) {
    var nodes = (root || document).querySelectorAll('[data-bc-campaign-end]');
    var now = Date.now();
    for (var i = 0; i < nodes.length; i++) {
      var iso = nodes[i].getAttribute('data-bc-campaign-end');
      var end = Date.parse(iso);
      if (isNaN(end)) { nodes[i].hidden = true; continue; }
      var msLeft = end - now;
      if (msLeft <= 0) { nodes[i].hidden = true; continue; }
      var days = Math.floor(msLeft / 86400000);
      if (days > 14) { nodes[i].hidden = true; continue; }
      nodes[i].hidden = false;
      nodes[i].textContent = days >= 1 ? pluralDays(days) : todayText();
    }
  }

  document.addEventListener('click', onClick);
  document.addEventListener('submit', onSubmit);
  document.addEventListener('DOMContentLoaded', function () { refreshCampaignBadges(document); });
  document.addEventListener('shopify:section:load', function (e) { refreshCampaignBadges(e.target); });
  setInterval(function () { refreshCampaignBadges(document); }, 5 * 60 * 1000);
})();
